//@ts-strict-ignore
import React from 'react';
import LuckinsItem from '../../graphql/entities/product/LuckinsItem';
import Workspace from '../../components/Workspace/Workspace';
import { useWorkspace } from '../../graphql/hooks/useWorkspace';
import { ILuckinsItem } from '../../graphql/schema/p4types';
import { Paths } from '../../@types/keyOfNested';

const { workspace, type, title } = LuckinsItem;

const LUCKINS_ITEM_FIELD_NAMES: Array<Paths<ILuckinsItem>> = ['shortDescription', 'otherDescription'];

const LuckinsItemWorkspace = (props) => {
  const workspaceProps = useWorkspace<ILuckinsItem>(props, LuckinsItem, {
    columns: LUCKINS_ITEM_FIELD_NAMES,
    initialSortColumn: 'id',
  });

  return (
    <Workspace
      ref={props.setWorkspaceRef}
      entityType={type}
      title={title}
      defaultQuery={workspace}
      {...workspaceProps}
      {...props}
      entity={LuckinsItem}
      formUrl={LuckinsItem.formUrl}
      permittedOperations={LuckinsItem.operations}
    />
  );
};

export default LuckinsItemWorkspace;
